import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import EditDetails from "./EditDetails";
import ProfileSkeleton from "../../util/ProfileSkeleton";

// MUI stuff
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import MuiLink from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
// Icons
import LocationOn from "@material-ui/icons/LocationOn";
import LinkIcon from "@material-ui/icons/Link";
import CalendarToday from "@material-ui/icons/CalendarToday";
import EditIcon from "@material-ui/icons/Edit";
import KeyboardReturn from "@material-ui/icons/KeyboardReturn";
//Redux
import { connect } from "react-redux";
import { IconButton } from "@material-ui/core";
import { logoutUser, uploadImage } from "../../redux/actions/userActions";

const styles = {
  paper: {
    padding: "20px",
    marginTop: "40px",
  },
  buttons: { padding: "10px" },
  profile: {
    "& .image-wrapper": {
      testAlign: "center",
      position: "relative",
      "& button": {
        position: "absolute",
        top: "80%",
        left: "70%",
      },
    },
    "& .profile-image": {
      width: 200,
      height: 200,
      objectFit: "cover",
      maxWidth: "100%",
      borderRadius: "50%",
    },
    "& .profile-details": {
      textAlign: "center",
      "& span, svg": {
        verticalAlign: "middle",
      },
    },
  },
};

class Profile extends Component {
  handleImageChange = (event) => {
    const image = event.target.files[0];
    const fromData = new FormData();
    fromData.append("image", image, image.name);
    this.props.uploadImage(fromData);
  };
  handleEditPicture = () => {
    const fileInput = document.getElementById("imageInput");
    fileInput.click();
  };
  handleLogout = () => {
    this.props.logoutUser();
  };
  render() {
    const {
      classes,
      user: {
        credentials: {
          handle,
          createdAt,
          imageUrl,
          bio,
          website,
          location,
          firstName,
          lastName,
          collegeName,
          streamName,
        },
        loading,
        authenticated,
      },
    } = this.props;

    let profileMarkup = !loading ? (
      authenticated ? (
        <Paper className={classes.paper}>
          <div className={classes.profile}>
            <div className="image-wrapper">
              <Grid container justify="center">
                <img src={imageUrl} alt="profile" className="profile-image" />
                <input
                  type="file"
                  id="imageInput"
                  hidden="hidden"
                  onChange={this.handleImageChange}
                />
                <Tooltip title="Edit profile picture" placement="top">
                  <IconButton
                    onClick={this.handleEditPicture}
                    className="button"
                  >
                    <EditIcon color="primary" />
                  </IconButton>
                </Tooltip>
              </Grid>

              {/* <MyButton
                tip="Edit profile picture"
                onClick={this.handleEditPicture}
                btnClassName="button"
              >
                <EditIcon color="primary" />
              </MyButton> */}
            </div>
            <hr />
            <div className="profile-details">
              <MuiLink
                component={Link}
                to={`/users/${handle}`}
                color="secondary"
                variant="h5"
              >
                @{handle}
              </MuiLink>
              <hr />
              {bio && (
                <Fragment>
                  <Typography variant="body2">Bio: {bio}</Typography>
                  <hr />
                </Fragment>
              )}
              {collegeName && (
                <Fragment>
                  <Typography variant="body1">
                    College: {collegeName}
                  </Typography>
                  {/* <hr /> */}
                </Fragment>
              )}
              {firstName && (
                <Fragment>
                  <Typography variant="body1">
                    Name: {firstName} {lastName}
                  </Typography>
                  {/* <hr /> */}
                </Fragment>
              )}
              {streamName && (
                <Fragment>
                  <Typography variant="body1">Stream: {streamName}</Typography>
                  <hr />
                </Fragment>
              )}
              {location && (
                <Fragment>
                  <LocationOn color="secondary" /> <span>{location}</span>
                  <hr />
                </Fragment>
              )}
              {website && (
                <Fragment>
                  <LinkIcon color="primary" />
                  <a href={website} target="_blank" rel="noopener noreferrer">
                    {" "}
                    {website}
                  </a>
                  <hr />
                </Fragment>
              )}
              <CalendarToday color="secondary" />{" "}
              <span>Joined At: {dayjs(createdAt).format("MMM YYYY")}</span>
            </div>
            <Tooltip title="Logout" placment="top">
              <IconButton onClick={this.handleLogout}>
                <KeyboardReturn color="primary"></KeyboardReturn>
              </IconButton>
            </Tooltip>
            <EditDetails />
            {/* <MyButton tip="Logout" onClick={this.handleLogout}>
              <KeyboardReturn color="primary" />
            </MyButton> */}
            {/* <EditDetails /> */}
          </div>
        </Paper>
      ) : (
        <Paper className={classes.paper}>
          <Typography variant="body2" align="center">
            No profile found, please login again
          </Typography>
          <div className={classes.buttons}>
            <Grid container justify="center">
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/login"
                style={{ marginRight: "10px" }}
              >
                Login
              </Button>
              <Button
                variant="contained"
                color="secondary"
                component={Link}
                to="/signup"
              >
                Signup
              </Button>
            </Grid>
          </div>
        </Paper>
      )
    ) : (
      <ProfileSkeleton />
    );

    return profileMarkup;
  }
}

const mapStateProps = (state) => ({
  user: state.user,
});

const mapActionsToProps = { logoutUser, uploadImage };

Profile.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  uploadImage: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateProps,
  mapActionsToProps
)(withStyles(styles)(Profile));
